<template>
  <div id="app">
    <v-app>
      <v-content class="pt-1">
         <v-container fluid fill-height class="back-image">
           <v-img height="140px" contain src="../assets/vFeedLogoLg.png" class="float-image"/>
           <v-layout align-center justify-center>
            <v-flex xs12 sm9 md7 lg5>
              <v-card class="elevation-12">
                <v-toolbar color="primary" flat>
                   <v-icon class="mr-3">mdi-account-plus</v-icon>
                  <v-toolbar-title>{{$t('Signup')}}</v-toolbar-title>
                </v-toolbar>
                <v-card-text class="pb-0 mb-4">
                  <v-form dense>
                    <v-text-field :label="$t('Full Name')" outlined
                        v-model="displayname"
                        type="text"
                        :rules="[rules.required]"
                        autocomplete="name" >
                        <v-icon slot="prepend" :class="{'small-icon': $vuetify.breakpoint.xs}" >mdi-account</v-icon>
                    </v-text-field>
                    <v-text-field :label="$t('e-mail')" outlined
                        v-model="username"
                        type="text"
                        :rules="[rules.required]"
                        autocomplete="email" >
                        <v-icon slot="prepend" :class="{'small-icon': $vuetify.breakpoint.xs}" >mdi-email</v-icon>
                    </v-text-field>
                    <v-layout>
                     <v-flex xs5 sm4>
                        <v-text-field  outlined
                           v-model="phone_country_code"
                           type="text"
                           autocomplete="tel-country-code" >
                           <v-icon slot="prepend" :class="{'small-icon': $vuetify.breakpoint.xs}" >mdi-phone</v-icon>
                           <div slot="label" style="font-size: 0.9em">{{$t('Country')}}<br />code</div>

                        </v-text-field>
                     </v-flex>
                     <v-flex xs7 sm8 class="ml-2">
                        <v-text-field :label="$t('Phone')" outlined
                           v-model="phone"
                           type="text"
                           autocomplete="tel" >
                        </v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-text-field :label="$t('Password')" outlined
                        v-model="password"
                        autocomplete="new-password"
                        :rules="[rules.required, rules.min]"
                        :type="showPass ? 'text' : 'password'"
                        :hint="$t('At least 8 characters')">
                        <v-icon slot="prepend" :class="{'small-icon': $vuetify.breakpoint.xs}" >mdi-lock</v-icon>
                        <v-icon slot="append" :class="{'small-icon': $vuetify.breakpoint.xs}" v-if="showPass" @click="showPass = !showPass">mdi-eye</v-icon>
                        <v-icon slot="append" :class="{'small-icon': $vuetify.breakpoint.xs}" v-if="!showPass" @click="showPass = !showPass">mdi-eye-off</v-icon>
                     </v-text-field>
                     <v-text-field :label="$t('Repeat password')" outlined
                        v-model="password2"
                        autocomplete="new-password"
                        :rules="[rules.required, rules.min, passwordConfirmationRule]"
                        :type="showPass ? 'text' : 'password'"
                        hint="At least 8 characters">
                        <v-icon slot="prepend" :class="{'small-icon': $vuetify.breakpoint.xs}" >mdi-lock</v-icon>
                        <v-icon slot="append" :class="{'small-icon': $vuetify.breakpoint.xs}" v-if="showPass" @click="showPass = !showPass">mdi-eye</v-icon>
                        <v-icon slot="append" :class="{'small-icon': $vuetify.breakpoint.xs}" v-if="!showPass" @click="showPass = !showPass">mdi-eye-off</v-icon>
                     </v-text-field>
                     <v-checkbox outlined color="primary"
                        v-model="accept_license">

                        <template v-slot:label>
                           <div>
                              {{$t('Accept the')}} <router-link to="/license">{{$t('License Agreement')}}</router-link>
                           </div>
                        </template>

                     </v-checkbox>
                  </v-form>
                </v-card-text>
                <v-card-actions class="pt-0">
                   <v-btn class="ma-2 mt-4 pa-3" outlined color="primary" @click="cancel">
                     <v-icon left>mdi-arrow-left-bold</v-icon> {{$t('Login')}}
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn  class="ma-2 mt-4 pa-2" color="primary" @click="register" :disabled="!accept_registration">
                     <v-icon left>mdi-account-check</v-icon > {{$t('Register')}}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
    </v-app>
  </div>
</template>

<script>
export default {
   name: "signup",
   data() {
      return {
        displayname: "",
        username: "",
        phone_country_code: "",
        phone: "",
        password: "",
        password2: "",
        accept_license: false,
        showPass: false,
        rules: {
            required: value => !!value || this.$i18n.t('Required.'),
            min: v => v.length >= 8 || this.$i18n.t('Min 8 characters'),
         }
      }
   },
   created() {
     },
   methods: {
      register() {
         try {
            //TODO Create new user (replace this)
            this.$store.dispatch("loginUser", {email: this.username, password: this.password})
            // if (this.saveLogin) {
            //    localStorage.setItem(this.$i18n.t('email'), this.username)
            //    localStorage.setItem(this.$i18n.t('Password'), this.password)
            // } else {
            //    localStorage.removeItem(this.$i18n.t('Password'));
            //    localStorage.removeItem(this.$i18n.t('email'));
            // }
         } catch (error) {
            this.$root.$globalSnackbar(this.$i18n.t('Fail to login') + ": " + error.message);
         }
      },
      cancel() {
         this.$router.replace({name: "login"});
      }
   },
   computed: {
      accept_registration() {
         return this.username && this.password && (this.password === this.password2) && this.accept_license;
      },
      passwordConfirmationRule() {
         return (this.password === this.password2) || this.$i18n.t('The passwords you entered do not match');
      },
   },
   watch: {
      currentUser() {
        this.$router.replace({name: "dashboard"});
      }
   }




};
</script>

<style>
   .float-image{
      position: fixed;
      top: 10%;
      left: 50%;
      transform: translateX(-50%);
   }
   .small-icon{
      font-size: 16px !important;
   }
   .small-height{
      line-height: 18px !important;
   }
</style>